import React from 'react';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import formatPrice from '../../helpers/formatPrice';
import './Discount.css';
import 'react-loading-skeleton/dist/skeleton.css';

function Discount({ type }) {
  const reduxState = useSelector((state) => state);
  const {
    quote: { dueDate },
    payments: {
      totalDiscountInReais,
      totalDiscountPercentage,
      poupancinha,
    },
  } = reduxState;

  const skeletonLoading = () => (
    <section id="discount" className={`text-center my-2 ${type ? 'w-70' : ''}`}>
      <Skeleton width="180px" height="25px" />
      <Skeleton width="150px" />
      <Skeleton width="200px" />
    </section>
  );

  return (
    poupancinha.length === 0
      ? skeletonLoading()
      : totalDiscountPercentage > 0
        && (
        <section id="discount" className={`text-center my-2 ${type ? 'w-70' : ''}`}>
          {/* <p className="my-0">
            {`${totalDiscountPercentage}% de Desconto!`}
          </p> */}
          <p className="my-0 text-danger payment">
            {`Economize: ${formatPrice(totalDiscountInReais)}`}
          </p>
          <p className="my-0">
            <strong>
              {'Desconto válido até: '}
              <span className="text-decoration-underline">{dueDate}</span>
            </strong>
          </p>
        </section>
        )
  );
}

Discount.propTypes = {
  type: PropTypes.bool,
};

Discount.defaultProps = {
  type: undefined,
};

export default Discount;
